import { Link } from "react-router-dom"
import { ID } from "src/libs/interfaces/layouts"

/* Protopia Ecosystem component */
export interface ILinkContainerProps {
   link_url?: string
   link_target?: string
   children: JSX.Element[] | JSX.Element
   className?: string
   style?: any 
   "data-type"?: string
   "data-content-id"?: string
   "data-primitive-type"?: string
   "data-primitive-id"?: ID
}
const LinkContainer = (props: ILinkContainerProps): JSX.Element[] | JSX.Element => {
    if( !props.link_url )
    {
        return <div className={`${props.className}`}  data-type={props["data-type"]} data-content-id={props["data-content-id"]}  data-primitive-type={props["data-primitive-type"]}>
            {props.children}
        </div>
    }
    else if(props.link_url.toString().indexOf("http") !== -1 || props.link_target === "_blank")
    {
        return <URLLink {...props } />
    }
    else
    {
        return <LinkLink {...props} />
    }
}

const URLLink = (props: ILinkContainerProps) =>
{
    return <a
        className={`hover ${props.className}`} 
        style={props.style} 
        href={props.link_url?.toString()} 
        target={props.link_target || "_blank"} 
        data-type={props["data-type"]}
        data-content-id={props["data-content-id"]}
        data-primitive-type={props["data-primitive-type"]}
        data-primitive-id={props["data-primitive-id"]}
    >
        {props.children}
    </a>
}
const LinkLink = (props: ILinkContainerProps) =>
{
    return <Link 
        className={`hover ${props.className}`} 
        style={props.style} 
        to={props.link_url?.toString()}
        data-type={props["data-type"]}
        data-content-id={props["data-content-id"]}  
        data-primitive-type={props["data-primitive-type"]}
    >
        {props.children}
    </Link>
}

export default LinkContainer